function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { property } from "lit/decorators.js";
import { QuoteController } from "./quote-controller.js";
import { SelectedState } from "./selected-state.js";
import { provide } from "@lit/context";
import { quoteContext } from "./quote-context.js";
import "../common/payment-element.js";
import offerBoxStyles from "./offer-box-styles.js";
import { BaseElement } from "./base-element.js";
import { OfferPaymentMixin } from "./mixin/offer-payment-mixin.js";
import { standardDisplayTemplate } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var _QuoteElement = /*#__PURE__*/function (_OfferPaymentMixin) {
  _inherits(_QuoteElement, _OfferPaymentMixin);

  var _super = _createSuper(_QuoteElement);

  function _QuoteElement(product) {
    var _this;

    _classCallCheck(this, _QuoteElement);

    _this = _super.call(this);
    _this.landingPageAction = false;
    _this.quoteContext = _this.quote;
    _this.product = product;
    _this.quoteController = new QuoteController(_assertThisInitialized(_this), function () {
      _this.quoteContext = _this.quote;

      _this.triggerOfferStateChangeEvent();
    });
    return _this;
  }

  _createClass(_QuoteElement, [{
    key: "quote",
    get: function get() {
      var _a;

      return (_a = this.quoteController) == null ? void 0 : _a.value;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(_QuoteElement.prototype), "connectedCallback", this).call(this);

      if (!document.getElementById("payment-component-style-overrides")) {
        var componentStyles = document.createElement("style");
        componentStyles.setAttribute("id", "vi-component-style-overrides");

        if (componentStyles) {
          componentStyles.innerHTML = "\n          :root {\n            --vi-font-fallback: ui-sans-serif, system-ui, sans-serif;\n            --default-vi-font-family: var(--vi-font-family, var(--vi-font-fallback));\n            --default-vi-header-font-family: var(--vi-header-font-family, var(--default-vi-font-family));\n            --default-vi-primary-color: var(--vi-primary-color, #FF6B00);\n            --default-vi-primary-contrast-color: var(--vi-primary-contrast-color, #FFF1E3);\n            --default-vi-font-sm: var(--vi-font-sm, 0.8rem);\n            --default-vi-font-md: var(--vi-font-md, 0.9rem);\n            --default-vi-font-lg: var(--vi-font-lg, 1.05rem);\n            --default-vi-font-xl: var(--vi-font-xl, 1.25rem);\n            --default-vi-secondary-color: var(--vi-secondary-color, #FF6B00);\n            --default-vi-secondary-contrast-color: var(--vi-secondary-contrast-color, #FFF1E3);\n            --default-vi-bg-color: var(--vi-bg-color, #ffffff);\n            --default-vi-success-color: var(--vi-success-color, #FF6B00);\n            --default-vi-success-bg-color: var(--vi-success-bg-color, #EFEFEE);\n            --default-vi-success-border-color: var(--vi-success-border-color, #918F8F);\n            --default-vi-danger-color: var(--vi-danger-color, #C71414);\n            --default-vi-danger-bg-color: var(--vi-danger-bg-color, #FDEDED);\n            --default-vi-danger-border-color: var(--vi-danger-border-color, #C71414);\n\n            --default-vi-accept-color: var(--vi-accept-color, #FF6B00);\n            --default-vi-accept-bg-color: var(--vi-accept-bg-color, #EFEFEE);\n            --default-vi-accept-border-color: var(--vi-accept-border-color, #918F8F);\n            --default-vi-decline-color: var(--vi-decline-color, #918F8F);\n            --default-vi-decline-bg-color: var(--vi-decline-bg-color, #EFEFEE);\n            --default-vi-decline-border-color: var(--vi-decline-border-color, #918F8F);\n\n            --default-vi-warning-color: var(--vi-warning-color, #fbbf24);\n            --default-vi-warning-bg-color: var(--vi-warning-bg-color, #fffbeb);\n            --default-vi-warning-border-color: var(--vi-warning-border-color, #fbbf24);\n            --default-vi-tag-color: var(--vi-tag-color, #FF6B00);\n            --default-vi-tag-contrast-color: var(--vi-tag-contrast-color, #ffffff);\n            --default-vi-tag-display: var(--vi-tag-display, block);\n            --default-vi-border-color: var(--vi-border-color, #949293);\n            --default-vi-border-radius: var(--vi-border-radius, 20px);\n            --default-vi-action-border-radius: var(--vi-action--border-radius, 4px);\n            --default-vi-container-padding: var(--vi-container-padding, 24px 16px 16px 16px);\n\n            --vi-multi-offer-header-font-size: 0.95rem;\n            --jfi-layout-padding: 0 0 4px 0;\n            --jfi-layout-form-control-spacing-x: .5rem;\n            --jfi-layout-form-control-spacing-y: 1rem;\n            --jfi-layout-font-family: var(--default-vi-font-family);\n            --jfi-form-label-font-family: var(--default-vi-font-family);\n            --jfi-primary-color: var(--default-vi-primary-color);\n            --jfi-form-control-background-color: #ffffff;\n            --jfi-form-control-border-color: rgb(226, 232, 240);\n            --jfi-form-control-border-color-focus: rgba(0, 0, 0, 0.62);\n            --jfi-form-control-border-color-error: var(--default-vi-danger-color);\n            --jfi-form-control-border-width: 1px;\n            --jfi-form-control-border-radius: 4px;\n            --jfi-form-control-border-style: solid;\n            --jfi-form-control-box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n            --jfi-form-control-box-shadow-error: rgba(199, 20, 20, 0.15) 0px 0px 0px 0px, rgba(199, 20, 20, 0.15) 0px 0px 0px 0px, rgba(199, 20, 20, 0.15) 0px 1px 2px 0px;\n            --jfi-form-control-box-shadow-error-focus: none;\n            --jfi-form-control-box-shadow-focus: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n            --jfi-form-control-color: var(--default-vi-primary-color);\n            --jfi-form-control-color-focus: var(--default-vi-primary-color);\n            --jfi-form-control-font-size: 0.85rem;\n            --jfi-form-control-font-weight: 400;\n            --jfi-form-control-line-height: 2;\n            --jfi-form-control-margin: 0;\n            --jfi-form-control-padding: .25rem .75rem;\n            --jfi-form-label-font-size: 0.95rem;\n            --jfi-form-label-color: var(--default-vi-primary-color);\n            --jfi-form-label-margin: 0 0 4px 2px;\n            --jfi-error-message-color: var(--default-vi-danger-color);\n            --jfi-error-message-margin: 4px 0 0 2px;\n            --jfi-error-message-font-size: var(--default-vi-font-sm);\n          }\n        ";
          document.body.append(componentStyles);
        }
      }
    }
    /**
     * @ignore
     */

  }, {
    key: "customer",
    get: function get() {
      return {
        first_name: this.customerFirstName,
        last_name: this.customerLastName,
        email_address: this.customerEmailAddress,
        street: this.customerStreetAddress,
        city: this.customerCity,
        state: this.customerState,
        postal_code: this.customerPostalCode
      };
    }
    /**
     * @ignore
     */

  }, {
    key: "productTemplate",
    get: function get() {
      var _a, _b, _c, _d, _e;

      return {
        promotional_header: ((_a = this.quote) == null ? void 0 : _a.product.promotional_header) || ((_b = this.quote) == null ? void 0 : _b.product.friendly_name),
        promotional_description: ((_c = this.quote) == null ? void 0 : _c.product.promotional_description) || void 0,
        accept_action_text: ((_d = this.quote) == null ? void 0 : _d.product.accept_action_text) || void 0,
        decline_action_text: ((_e = this.quote) == null ? void 0 : _e.product.decline_action_text) || "Decline coverage"
      };
    }
  }, {
    key: "accept",
    value: function accept() {
      this.errors = [];
      this.selectedState = SelectedState.ACCEPTED;
      this.triggerOfferStateChangeEvent();
    }
  }, {
    key: "decline",
    value: function decline() {
      this.errors = [];
      this.selectedState = SelectedState.DECLINED;
      this.triggerOfferStateChangeEvent();
    }
  }, {
    key: "total",
    get: function get() {
      var _a, _b;

      return ((_a = this.quote) == null ? void 0 : _a.total) || ((_b = this.quote) == null ? void 0 : _b.premium_amount);
    }
    /**
     * @ignore
     */

  }, {
    key: "quoteId",
    get: function get() {
      var _this2 = this;

      var _a;

      var quoteId = (_a = document.cookie.split("; ").find(function (row) {
        return row.split("=")[0] === _this2.cookieName;
      })) == null ? void 0 : _a.split("=")[1];
      return quoteId;
    }
    /**
     * @ignore
     */
    ,
    set: function set(quoteId) {
      document.cookie = "".concat(this.cookieName, "=").concat(quoteId, ";path=/;max-age=604800;");
    }
    /**
     * @ignore
     */

  }, {
    key: "unsetQuoteId",
    value: function unsetQuoteId() {
      document.cookie = "".concat(this.cookieName, "=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;");
    }
  }, {
    key: "cookieName",
    get: function get() {
      var _a, _b;

      return ((_a = this.dataset) == null ? void 0 : _a.uniqueId) ? "vertical_insure_quote_id:".concat(this.product, ":").concat((_b = this.dataset) == null ? void 0 : _b.uniqueId) : "vertical_insure_quote_id:".concat(this.product);
    }
    /**
     * @ignore
     */

  }, {
    key: "offerId",
    get: function get() {
      var _this3 = this;

      var _a;

      var offerId = (_a = document.cookie.split("; ").find(function (row) {
        return row.split("=")[0] === _this3.offerIdCookieName;
      })) == null ? void 0 : _a.split("=")[1];
      return offerId;
    }
    /**
     * @ignore
     */
    ,
    set: function set(offerId) {
      document.cookie = "".concat(this.offerIdCookieName, "=").concat(offerId, ";max-age=604800;");
    }
    /**
     * @ignore
     */

  }, {
    key: "unsetOfferId",
    value: function unsetOfferId() {
      document.cookie = "".concat(this.offerIdCookieName, "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;");
    }
  }, {
    key: "offerIdCookieName",
    get: function get() {
      return "vertical_insure_offer_id:".concat(this.product);
    }
  }, {
    key: "displayPaymentElement",
    get: function get() {
      return this.selectedState === SelectedState.ACCEPTED && this.includePaymentElement;
    }
  }, {
    key: "triggerOfferStateChangeEvent",
    value: function triggerOfferStateChangeEvent() {
      var options = {
        detail: {
          quote: this.quote,
          selectedState: SelectedState[this.selectedState]
        },
        bubbles: true,
        composed: true
      };
      this.dispatchEvent(new CustomEvent("offer-state-change", options));

      if (this.debug) {
        console.debug("Fired offer-state-change event", options.detail);
      }
    }
  }, {
    key: "toggleOfferSelection",
    value: function toggleOfferSelection() {
      if (this.selectedState === SelectedState.ACCEPTED) {
        this.decline();
      } else {
        this.accept();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return this.quoteController.render({
        complete: function complete() {
          return _this4._renderStandardDisplay();
        }
      });
    }
  }, {
    key: "_renderStandardDisplay",
    value: function _renderStandardDisplay() {
      var _this5 = this;

      return standardDisplayTemplate(this.selectedState, this.accept, this.decline, function () {
        return _this5.renderPaymentElement();
      }, this.landingPageAction, this.quote, this.productTemplate, this.errors);
    }
  }]);

  return _QuoteElement;
}(OfferPaymentMixin(BaseElement));

_QuoteElement.styles = offerBoxStyles;
var QuoteElement = _QuoteElement;

__decorateClass([property({
  attribute: "customer-first-name"
})], QuoteElement.prototype, "customerFirstName", 2);

__decorateClass([property({
  attribute: "customer-last-name"
})], QuoteElement.prototype, "customerLastName", 2);

__decorateClass([property({
  attribute: "customer-email-address"
})], QuoteElement.prototype, "customerEmailAddress", 2);

__decorateClass([property({
  attribute: "customer-street-address"
})], QuoteElement.prototype, "customerStreetAddress", 2);

__decorateClass([property({
  attribute: "customer-state"
})], QuoteElement.prototype, "customerState", 2);

__decorateClass([property({
  attribute: "customer-city"
})], QuoteElement.prototype, "customerCity", 2);

__decorateClass([property({
  attribute: "customer-postal-code"
})], QuoteElement.prototype, "customerPostalCode", 2);

__decorateClass([property({
  type: Boolean,
  attribute: "landing-page-action"
})], QuoteElement.prototype, "landingPageAction", 2);

__decorateClass([provide({
  context: quoteContext
})], QuoteElement.prototype, "quoteContext", 2);

export { QuoteElement };